(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rotating-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function afficher(col, texte) {
      var courant = col.__cur;
      var el = document.createElement('span');
      el.className = 'rotateur2__mot';
      el.textContent = texte;
      // le nouveau texte arrive par le haut
      el.style.transition = 'none';
      el.style.transform = 'translateY(-100%)';
      col.appendChild(el);
      void el.offsetHeight;
      el.style.transition = '';
      el.style.transform = 'translateY(0)';
      if (courant) {
        courant.style.transform = 'translateY(100%)';
        setTimeout(function () {
          if (courant.parentNode) courant.parentNode.removeChild(courant);
        }, 800);
      }
      col.__cur = el;
    }

    function init(racine) {
      if (racine.__rot) clearInterval(racine.__rot);
      var delai = parseInt(racine.getAttribute('data-delai'), 10) || 2000;
      var sources = racine.querySelectorAll('.rotateur2__source > span');
      var items = [];
      for (var k = 0; k < sources.length; k++) {
        items.push({
          a: sources[k].getAttribute('data-article'),
          m: sources[k].getAttribute('data-mot')
        });
      }
      if (items.length < 2) return;

      var colA = racine.querySelector('.rotateur2__col--article');
      var colM = racine.querySelector('.rotateur2__col--mot');
      colA.__cur = colA.querySelector('.rotateur2__mot');
      colM.__cur = colM.querySelector('.rotateur2__mot');

      var i = 0;
      racine.__rot = setInterval(function () {
        var precedent = items[i];
        i = (i + 1) % items.length;
        var suivant = items[i];
        afficher(colM, suivant.m);
        // l'article ne bouge que s'il change
        if (suivant.a !== precedent.a) afficher(colA, suivant.a);
      }, delai);
    }

    function toutInit(parent) {
      var liste = parent.querySelectorAll('[data-rotateur-duo]');
      for (var n = 0; n < liste.length; n++) init(liste[n]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { toutInit(document); });
    } else {
      toutInit(document);
    }
    document.addEventListener('shopify:section:load', function (e) { toutInit(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var liste = e.target.querySelectorAll('[data-rotateur-duo]');
      for (var n = 0; n < liste.length; n++) clearInterval(liste[n].__rot);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
